export enum PRRoutesEnum {
  CUSTOMERS = 'customers',
  PROJECTS = 'projects',
  PROJECTS_OVERVIEW = 'projects-overview',
  DASHBOARD_WITH_PROJECT_ID = ':projectId/dashboard',
  DOCUMENTS_WITH_PROJECT_ID = ':projectId/documents',
  INBOX_WITH_PROJECT_ID = ':projectId/inbox',
  DASHBOARD = 'dashboard',
  DOCUMENTS = 'documents',
  DOCUMENT_PREVIEW = 'document',
  INBOX = 'inbox',
  ACCESS_DENIED = 'access_denied',
}